import QS from 'qs'
import Cookies from 'js-cookie'
import { compareVersions } from 'compare-versions'
import NoSleep from 'nosleep.js'
import Jax from '@bxs/jax'

import { addPbCount, completeMission, resultShare, wxClientSaveOperate } from 'api/index'
import { pbfUrl } from 'api/config'
import Oauth from '@/base/oauth.js'
import Share from '@/base/model/share.js'
import Wechat from '@/base/wechat.js'
import { AP_ASHEET, icons } from '@/pages/planbkTemplate/base/config'
import { IS_PRODUCT_ENV, URL_PARAM } from '@/utils/variables.js'
import { bApp, isBxs, inWechat, isBroker, isYjjApp, isToBApp, isWeCom, isMiniBankInsurance, APPID, wxMpAppid, componentAppid, POLICY_WECHAT_SHARED_LOGO, POLICY_SHARE_DECS, SHARE_DECS } from '@/base/config.js'

export async function initNativeShare (options = {}) {
  const { uuid } = URL_PARAM
  const {
    $refs,
    isMiniprogram,
    isPolicyCheck,
    isSupportRecordScreen,
    isForPresentation,
    showType,
    title,
    tmpData,
    getThemeSettings,
    getAppParams,
    callback
  } = options
  const { card, insuranceType, resultData } = tmpData
  const cardUuid = URL_PARAM.cardUuid || (card && card.uuid) || ''
  const name = card && card.name
  const img = isPolicyCheck ? POLICY_WECHAT_SHARED_LOGO : (insuranceType ? insuranceType.wechatSharedLogoUrl : '')
  const insuranceTypeId = resultData.insuranceTypeId

  const themeSettings = (typeof getThemeSettings === 'function') && getThemeSettings() || {}
  const urlParams = {
    ...URL_PARAM,
    theme: themeSettings.previewTheme,
    cardUuid,
    inGroup: true,
    dfSort: showType,
    isShareFormWeApp: 1
  }
  if (isBroker) {
    urlParams.app = 'Broker'
  } else if (isToBApp || isWeCom) {
    urlParams.app = Cookies.get('appId')
  }
  const shareLink = `${location.origin + location.pathname}?${QS.stringify(urlParams)}`
  const baseConfig = {
    desc: `${name}${isPolicyCheck ? POLICY_SHARE_DECS : SHARE_DECS}`,
    bizChannel: 'jhs',
    taskId: 'share_planbook',
    title,
    img
  }

  // wxwork
  if (isWeCom && window.WeCom && WeCom.initWeComConfig) {
    const appParams = await getAppParams()
    WeCom.initWeComConfig({
      title: baseConfig.title,
      desc: baseConfig.desc,
      imgUrl: baseConfig.img,
      link: `${location.origin + location.pathname}?${QS.stringify({
        ...urlParams,
        ...appParams,
        theme: themeSettings.previewTheme,
        nocard: 1 // 隐藏名片
      })}`,
      success: () => {
        resultShare({ uuid })
      }
    }, true)
    return
  }

  // 小程序
  if (isMiniprogram) {
    const miniShareURL = `${location.origin + location.pathname}?${QS.stringify({
      ...urlParams,
      theme: themeSettings.previewTheme,
      nobar:  1 // 隐藏功能栏
    })}`
    // 银保小程序
    if (isMiniBankInsurance && WeCom.initMiniConfig) {
      WeCom.initMiniConfig({
        title: baseConfig.title,
        desc: baseConfig.desc,
        imgUrl: baseConfig.img,
        link: miniShareURL
      })
    } else {
      wx.miniProgram.postMessage({
        data: {
          shareConfig: {
            title: baseConfig.title,
            imageUrl: '', // baseConfig.img，图片尺寸问题不使用，使用页面截图
            shareUrl: miniShareURL
          }
        }
      })
    }
    return
  }

  let asConfig = null
  const lazyDataCb = async config => {
    let params = {
      ...urlParams
    }
    if (['wechat_timeline', 'wechat_friends'].includes(config.action)) {
      const lazyThemeSettings = (typeof getThemeSettings === 'function') && getThemeSettings() || {}
      const appParams = await getAppParams()
      params = {
        ...params,
        ...appParams,
        theme: lazyThemeSettings.previewTheme
      }
    }

    if ($refs.InterestDemoV2) {
      const newResultUuid = await $refs.InterestDemoV2.save()
      params.uuid = newResultUuid || params.uuid
    }
    addPbCount({ uuid, type: 'pb_share'})
    completeMission({ SourceId: uuid, missionCode: 'share_planbook' })
    resultShare({ uuid })
    window.WeiyiStatSDK.submit('share')
    const _config = new Share({
      ...config,
      link: `${location.origin + location.pathname}?${QS.stringify(params)}`
    })
    console.clear()
    console.log(_config.shareUrl)
    return _config
  }
  if (bApp && appBridge && appBridge.checkAppFeature(AP_ASHEET)) {
    const shareChannels = ['qq_friends', 'wechat_timeline', 'wechat_friends']
    // 系统分享，主要用于隐藏分享来源。保险师IOS6.6.0开始支持,安卓6.6.1开始支持。
    const appVersion = Jax.getAppVersion()
    const isIosSupport = appBridge.isIos() && compareVersions(appVersion, '6.6.0') >= 0
    const isAndroidSupport = appBridge.isAndroid() && compareVersions(appVersion, '6.6.1') >= 0
    if (isIosSupport || isAndroidSupport) {
      shareChannels.push('system_share')
    }
    // bxs：加入小程序和钉钉
    if (isBxs) {
      shareChannels.push('miniProgramData')
      shareChannels.push('ding_talk')
    }

    const shareGroup = shareChannels.map(channel => {
      if (channel === 'miniProgramData') {
        return {
          action: channel,
          webPageUrl: 'http://www.winbaoxian.com/',
          userName: 'gh_db166d39960f',
          path: `/pages/result/index?uuid=${uuid}&theme=${themeSettings.previewTheme}&t=1`,
          title: '买保险优选服务',
          description: `${IS_PRODUCT_ENV ? '' : '(测试版)'}${title}，${name}为您定制`,
          imageUrl:
            'http://img.winbaoxian.com/autoUpload/planbook/__87080b709204b35.png',
          miniProgramType: IS_PRODUCT_ENV ? 0 : 2
        }
      }
      const config = {
        ...baseConfig,
        action: channel
      }
      return new Share({
        ...config,
        cb: lazyDataCb.bind(null, config)
      })
    })

    const actionGroup = [
      { action: 'text_zoom' }
    ]
    if (isBxs || isToBApp) {
      actionGroup.push({
        action: {
          action: 'custom_feedback',
          title: '反馈',
          icon: icons.feedback
        },
        customActionHandler () {
          if (isForPresentation) {
            return
          }
          location.href = `${pbfUrl}/planBook/projectGroup/feedback/index.html?nw=1&type=8&planbookId=${insuranceTypeId}`
        }
      })
    }
    if (isBxs || isYjjApp) {
      actionGroup.push({
        action: {
          action: 'invitation',
          title: '同屏讲解',
          icon: icons.invitation
        },
        customActionHandler () {
          if (isForPresentation) {
            return
          }
          callback && callback({
            isPreInvitationShow: true
          })
        }
      })
    }
    if ((isBxs || isToBApp) && isSupportRecordScreen) {
      actionGroup.push({
        action: {
          action: 'record_screen',
          title: '录制视频',
          icon: icons.recordScreen
        },
        customActionHandler () {
          if (isForPresentation) {
            return
          }
          callback && callback({
            recordScreenShow: true
          })
        }
      })
    }
  
    asConfig = {
      title: '',
      channel: 'jhs',
      shareGroup,
      actionGroup,
      expire: {
        options: appBridge.PRESET_ACTIONSHEET_SHARE_EXPIRE_PERIODS,
        urlAfterExpire: shareGroup[0].shareUrl + `&wy_expire=${new Date().getTime()}`
      }
    }

    // // 调试
    // shareGroup.forEach(ele => {
    //   ele.lazyDataCb && ele.lazyDataCb()
    // })
    // actionGroup.forEach(ele => {
    //   if (ele.action && ele.action.action === 'custom_feedback') {
    //     return
    //   }
    //   ele.customActionHandler && ele.customActionHandler()
    // })
    // console.error('调试用，上线请删除')

    appBridge.commonActionSheet(asConfig)
    if (appBridge && appBridge.checkAppFeature('ON_APP_BACK_TO_INPUT_PAGE')) {
      appBridge.onAppBackToInputPage(() => {
        appBridge.commonActionSheet(asConfig)
        $refs.recordScreen.getRecordScreenStatus()
      })
    }
  }
  callback && callback({
    shareLink,
    asConfig
  })
}

export async function initWechatShare (options = {}) {
  const {
    token,
    title,
    tmpData,
    isMiniprogram,
    isPolicyCheck,
    isReplay,
    fromWyjhs,
    showType,
    callback
  } = options

  const operateParams = {
    token,
    title,
    showType,
    tmpData,
    isMiniprogram,
    isPolicyCheck
  }

  // 银保小程序：非微信授权，在小程序内保存用户行为
  if (isMiniprogram && isMiniBankInsurance && WeCom.initMiniConfig) {
    saveOperate(operateParams)
    return
  }

  // 授权：微信下，且非小程序、非同屏讲解回放（isReplay）、非企业微信（isWeCom）、!fromWyjhs
  if (!inWechat || isMiniprogram || isReplay || isWeCom || fromWyjhs ) {
    return
  }

  // 微信授权并保存用户行为记录
  let isAuthed = null
  if (URL_PARAM.page_form !== 'crm') {
    isAuthed = await Oauth({
      token,
      wxMpAppid,
      componentAppid
    }).catch(() => {})
  }
  saveOperate({
    ...operateParams,
    isAuthed
  }).then(res => {
    if (res && callback) {
      callback && callback({
        clientUuid: res.clientUuid,
        insuranceTypeId: res.insuranceTypeId,
        heartSec: res.heartSec
      })
    }
  })
}

// 保存行为记录
export async function saveOperate (options = {}) {
  const { uuid, pathUuid } = URL_PARAM
  const {
    token,
    title,
    showType,
    tmpData,
    isMiniprogram,
    isPolicyCheck,
    isAuthed
  } = options

  const { card, insuranceType, resultData, heartSec } = tmpData
  const cardUuid = URL_PARAM.cardUuid || (card && card.uuid) || ''
  const userStrId = URL_PARAM.userUuid || (card && card.userUuid) || ''
  const name = card && card.name ? card.name : ''
  const img = isPolicyCheck ? POLICY_WECHAT_SHARED_LOGO : (insuranceType ? insuranceType.wechatSharedLogoUrl : '')
  const oauthExtendMsg = insuranceType ? insuranceType.name : null
  const insuranceTypeId = resultData.insuranceTypeId

  const baseParams = {
    userStrId, // 代理人标识
    source: 4,
    operate: appBridge && appBridge.isCurrentSharedPageExpired && appBridge.isCurrentSharedPageExpired() ? 'view2' : 'view',
    linkId: uuid,
    businessId: insuranceTypeId, // 获客行为产品ID
    dynamicMsg: [oauthExtendMsg], // 获客行为动态文案
    previousOperateUuid: pathUuid, // 上一个分享人的行为UUID，当前接口返回
    jumpUrl: `${location.origin}${location.pathname}?nw=1&uuid=${uuid}&cardUuid=${cardUuid}`,
    humanPathFlag: true
  }

  // 银保小程序行为轨迹
  if (isMiniprogram && isMiniBankInsurance && WeCom.initMiniConfig) {
    WeCom.initMiniConfig({
      ...baseParams,
      // 银保小程序特有
      // 指定分享链接上承载 previousOperateUuid 的 key
      pathUuid: 'pathUuid'
    })
    return
  }

  const urlParams = {
    ...URL_PARAM,
    dfSort: showType,
    autoOauth: undefined,
    fromWyjhs: undefined
  }
  if (URL_PARAM.page_form === 'crm') {
    urlParams.page_crm = 'customer'
  }

  const wxConfig = {
    action: 'wechat',
    link: `${location.origin + location.pathname}?${QS.stringify(urlParams)}`,
    desc: `${name}${SHARE_DECS}`,
    title,
    img,
    success: function () {
      window.WeiyiStatSDK.submit('share')
    }
  }
  if (isAuthed) {
    try {
      const { data, info } = await wxClientSaveOperate({
        appId: wxMpAppid, // 微信授权APP_ID
        token,
        userAppId: APPID, // 保险师 独代 企微
        ...baseParams
      })
      console.warn('[Operate]', info)
      urlParams.pathUuid = data.operateUuid
      urlParams.isShareFormWeApp = 1
      urlParams.token = undefined
      wxConfig.link = `${location.origin + location.pathname}?${QS.stringify(urlParams)}`
      Wechat(new Share(wxConfig), location.href, wxMpAppid)
      return {
        ...data,
        insuranceTypeId,
        heartSec
      }
    } catch (err) {
      Wechat(new Share(wxConfig), location.href, wxMpAppid)
      console.warn('[Operate]', err)
      return new Error(err)
    }
  } else {
    Wechat(new Share(wxConfig), location.href, wxMpAppid)
  }
}

const noSleep = new NoSleep();
export function enableNoSleep () {
  if (
    window.appBridge &&
    appBridge.isApp() &&
    appBridge.checkAppFeature('SET_KEEP_SCREEN_ON')
  ) {
    appBridge.setKeepScreenOn({ isOn: true })
    return
  }
  document.addEventListener('click', function _enableNoSleep() {
    document.removeEventListener('click', _enableNoSleep, false);
    noSleep.enable();
  }, false);
}

export function disableNoSleep () {
  if (
    window.appBridge &&
    appBridge.isApp() &&
    appBridge.checkAppFeature('SET_KEEP_SCREEN_ON')
  ) {
    appBridge.setKeepScreenOn({ isOn: false })
    return
  }
  noSleep.disable();
}

export function showTopArrow() {
  var box = document.createElement('div')
  box.innerHTML = `<div style='position: fixed;width: 100%;height: 100%;left: 0;top: 0;background: rgba(0, 0, 0, 0.5); z-index: 100000'>
    <img src='//res.winbaoxian.com/static/qw/tip.png' style='width: 60%;display: block;margin: 5px 0 0 36%'>
  </div>`
  document.body.appendChild(box)
  box.onclick = function() {
    document.body.removeChild(box)
  }
}
